import { SEARCHABLE_ITEMS } from './search';

export interface Favorite {
    title: string;
    path: string;
    description?: string;
}

const FAVORITES_KEY = 'origami_favorites';

const DEFAULT_FAVORITES: Favorite[] = [
    {
        title: 'Agreements',
        path: '/agreements',
        description: 'Access contracts and related documents'
    },
    {
        title: 'AI Copilot',
        path: '/ai',
        description: 'Licensing AI with contract, royalties, and industry context'
    },
    {
        title: 'Licensing KPIs',
        path: '/analytics/licensing-kpi/amu-metrics',
        description: 'Real time royalties and MSS reporting'
    }
];

const getDescriptionForPath = (path: string): string | undefined => {
    return SEARCHABLE_ITEMS.find((item) => item.path === path)?.subtitle;
};

export const getFavorites = (): Favorite[] => {
    try {
        const stored = localStorage.getItem(FAVORITES_KEY);
        if (!stored) {
            localStorage.setItem(FAVORITES_KEY, JSON.stringify(DEFAULT_FAVORITES));
            return DEFAULT_FAVORITES;
        }
        const favorites = JSON.parse(stored);
        return favorites.map((fav: Favorite) => ({
            ...fav,
            description: fav.description || getDescriptionForPath(fav.path)
        }));
    } catch {
        return DEFAULT_FAVORITES;
    }
};

export const addFavorite = (favorite: Favorite): void => {
    const favorites = getFavorites();
    if (!favorites.some((f) => f.path === favorite.path)) {
        const description = favorite.description || getDescriptionForPath(favorite.path);
        favorites.push({ ...favorite, description });
        localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    }
};

export const removeFavorite = (path: string): void => {
    const favorites = getFavorites().filter((f) => f.path !== path);
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
};

export const isFavorite = (path: string): boolean => {
    return getFavorites().some((f) => f.path === path);
};

export const reorderFavorites = (favorites: Favorite[]): void => {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
};
